import config from 'lib/config';

let initialized = false;

const conversionIds = [
  config.googleAdwordsConversionIdNew,
  config.googleAdwordsConversionIdOld,
];

function send() {
  window.dataLayer = window.dataLayer || [];
  // For some reason this only works with Arguments object
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

function initialize() {
  send('js', new Date());
  // https://developers.google.com/adwords-remarketing-tag/#configuring_the_global_site_tag_for_multiple_accounts
  conversionIds.forEach((conversionId) => send('config', conversionId));
  initialized = true;
}

function gtag(...args) {
  if (!initialized) {
    initialize();
  }
  send(...args);
}

function sendToParams() {
  return conversionIds.map((id) => `AW-${id}`);
}

function track(params = {}) {
  const eventParams = params.eventParams || {};
  eventParams.send_to = sendToParams();
  gtag('event', params.eventName, eventParams);
}

// eslint-disable-next-line import/prefer-default-export
export function trackHomepageView() {
  track({ eventName: 'page_view', eventParams: { dynx_pagetype: 'home' } });
}

export function trackConversion(vin, cpl, geolocation) {
  const eventParams = {
    dynx_itemid: vin,
    dynx_pagetype: 'conversion',
    currency: 'USD',
    value: cpl,
  };
  eventParams.send_to = sendToParams();

  if (geolocation) {
    eventParams.dynx_locid = `${geolocation.latitude},${geolocation.longitude}`;
  }

  gtag('event', 'conversion', eventParams);

  gtag('event', 'conversion', {
    ...eventParams,
    send_to: 'AW-1041740404/OMlfCLKGm50BEPTk3vAD',
  });
}

export default {
  trackHomepageView,
  trackConversion,
};
